const readable = {
	name: 'Lesebestätigung | Lesebestätigungen',
	icon: '',
	fields: {
		user_fullname: 'Name',
		user_email: 'E-Mail',
		read_on: 'Gelesen am',
	},
}

export default readable
